import { type FC } from 'react'
import { usePagination } from 'react-instantsearch'

import { productSearchPaginationBuildPaginationItems } from './productSearchPaginationBuildPaginationItems'
import {
  type PaginationItem,
  ProductSearchPaginationItem,
} from './ProductSearchPaginationItem'

export const ProductSearchPagination: FC = () => {
  const pagination = usePagination()

  const paginationItems =
    productSearchPaginationBuildPaginationItems(pagination)

  // this will be done in a separate ticket
  if (pagination.nbPages === 0) {
    return null
  }

  return (
    <div className="mt-4 flex w-full justify-end" data-qa-id="pagination-links">
      <ul className="my-4 flex list-none items-center">
        {paginationItems.map((paginationItem: PaginationItem) => (
          <li key={paginationItem.pageNumber + paginationItem.renderType}>
            <ProductSearchPaginationItem
              paginationItem={paginationItem}
              refine={() => {
                pagination.refine(paginationItem.pageNumber)
              }}
            />
          </li>
        ))}
      </ul>
    </div>
  )
}
